export const BenqDataSet = [
   {
     "team": "老屁股起來動一動",
     "total": 42,
     "weight": 0,
     "members": [
        {
           "name": "俞昱安 ",
           "score": 8
        },
        {
           "name": "林唐誌",
           "score": 1
        },
        {
           "name": "LULU",
           "score": 14
        },
        {
           "name": "Ken ",
           "score": 11
        },
        {
           "name": "Nicole",
           "score": 8
        }
     ]
  },
   {
     "team": "【Qisda】外出健走靠朋友",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "林畊螗",
           "score": 21
        },
        {
           "name": "洪惠芸",
           "score": 21
        },
        {
           "name": "陳威凱",
           "score": 21
        },
        {
           "name": "陳耀傑",
           "score": 21
        },
        {
           "name": "楊豊閎",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】走在一起",
     "total": 105,
     "weight": 1,
     "members": [
        {
           "name": "許翡珊",
           "score": 21
        },
        {
           "name": "李明倫",
           "score": 21
        },
        {
           "name": "陳彩芬",
           "score": 21
        },
        {
           "name": "徐士恆",
           "score": 21
        },
        {
           "name": "林鈺斐",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】一起瘋運動",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林伯鈞",
           "score": 21
        },
        {
           "name": "馬翔武",
           "score": 21
        },
        {
           "name": "張謙豪",
           "score": 21
        },
        {
           "name": "談氏河",
           "score": 21
        },
        {
           "name": "黎氏梅霜",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】是不是這樣的夜晚你會想起我",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "王政欽",
           "score": 21
        },
        {
           "name": "張永政",
           "score": 21
        },
        {
           "name": "黃政桐",
           "score": 21
        },
        {
           "name": "鄺倩影",
           "score": 21
        },
        {
           "name": "許文詮",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】哥斯拉",
     "total": 35,
     "weight": 0,
     "members": [
        {
           "name": "阮春財",
           "score": 5
        },
        {
           "name": "徐國智",
           "score": 2
        },
        {
           "name": "張建湋",
           "score": 12
        },
        {
           "name": "廖文唯",
           "score": 15
        },
        {
           "name": "蔡明穎",
           "score": 1
        }
     ]
  },
   {
     "team": "【Qisda】運動好棒棒",
     "total": 95,
     "weight": 0,
     "members": [
        {
           "name": "李東原",
           "score": 18
        },
        {
           "name": "陳麗秀",
           "score": 21
        },
        {
           "name": "黃于容",
           "score": 19
        },
        {
           "name": "劉惠卿",
           "score": 20
        },
        {
           "name": "蔣玉韻",
           "score": 17
        }
     ]
  },
   {
     "team": "【Qisda】犇起來",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "王郁錡",
           "score": 21
        },
        {
           "name": "周佩芸",
           "score": 21
        },
        {
           "name": "鄭安森",
           "score": 21
        },
        {
           "name": "顏心怡",
           "score": 21
        },
        {
           "name": "尤聖媛",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】就是愛運動",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "游瑞娟",
           "score": 21
        },
        {
           "name": "黃玉珮",
           "score": 21
        },
        {
           "name": "劉秀錦",
           "score": 21
        },
        {
           "name": "黎香勝",
           "score": 21
        },
        {
           "name": "李端哲",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】天下無敵宇宙隊",
     "total": 71,
     "weight": 0,
     "members": [
        {
           "name": "吳俊豪",
           "score": 20
        },
        {
           "name": "邱繼政",
           "score": 20
        },
        {
           "name": "丁博彥",
           "score": 19
        },
        {
           "name": "李全堃",
           "score": 6
        },
        {
           "name": "裴俊英",
           "score": 6
        }
     ]
  },
   {
     "team": "【Qisda】酷斯拉",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "杜文興",
           "score": 21
        },
        {
           "name": "周氏雪",
           "score": 21
        },
        {
           "name": "張秀琳",
           "score": 20
        },
        {
           "name": "謝淑華",
           "score": 21
        },
        {
           "name": "鍾定原",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】隨便走走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "王祐鈞",
           "score": 21
        },
        {
           "name": "吳啟誠",
           "score": 21
        },
        {
           "name": "李美玉",
           "score": 21
        },
        {
           "name": "陳科霖",
           "score": 21
        },
        {
           "name": "楊玉蘭",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】躍起動力",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "邱麗美",
           "score": 21
        },
        {
           "name": "范沐塵",
           "score": 21
        },
        {
           "name": "張明珠",
           "score": 21
        },
        {
           "name": "范淑珍",
           "score": 21
        },
        {
           "name": "吳麗敏",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】顧好腰子",
     "total": 90,
     "weight": 0,
     "members": [
        {
           "name": "王嘉蘭",
           "score": 14
        },
        {
           "name": "陳加涓",
           "score": 21
        },
        {
           "name": "劉啟璋",
           "score": 14
        },
        {
           "name": "蔡佩珊",
           "score": 20
        },
        {
           "name": "賴威辰",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】團結",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "賴鈺樑",
           "score": 21
        },
        {
           "name": "陳文彬",
           "score": 21
        },
        {
           "name": "葉雪玉",
           "score": 21
        },
        {
           "name": "曾國璋",
           "score": 21
        },
        {
           "name": "劉麗華 ",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】一致",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "鍾玉珍",
           "score": 21
        },
        {
           "name": "張淑慧",
           "score": 21
        },
        {
           "name": "徐美香",
           "score": 21
        },
        {
           "name": "林燕婷",
           "score": 21
        },
        {
           "name": "鄧永乾",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】犇跑",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "卓秀清",
           "score": 20
        },
        {
           "name": "劉淑媛",
           "score": 20
        },
        {
           "name": "林哲民",
           "score": 19
        },
        {
           "name": "卓宗憲",
           "score": 20
        },
        {
           "name": "葉芊蘭",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】BQ走路工",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林詠智",
           "score": 21
        },
        {
           "name": "張婷華",
           "score": 21
        },
        {
           "name": "張紫馨",
           "score": 21
        },
        {
           "name": "劉玟葶",
           "score": 21
        },
        {
           "name": "蔡立婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】DR旺旺動一動",
     "total": 87,
     "weight": 0,
     "members": [
        {
           "name": "陳烽霖",
           "score": 18
        },
        {
           "name": "王美莉",
           "score": 15
        },
        {
           "name": "詹益宗",
           "score": 16
        },
        {
           "name": "廖仁豪",
           "score": 19
        },
        {
           "name": "曾瑞琴",
           "score": 19
        }
     ]
  },
   {
     "team": "【BenQ】Peter三鐵賽加油",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "呂至偉",
           "score": 21
        },
        {
           "name": "李鴻彬",
           "score": 21
        },
        {
           "name": "孫鵬宗",
           "score": 21
        },
        {
           "name": "劉國慶",
           "score": 21
        },
        {
           "name": "鄒孟廷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】QA",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "聶香泰",
           "score": 21
        },
        {
           "name": "阮武薔薇",
           "score": 20
        },
        {
           "name": "黃冠評",
           "score": 21
        },
        {
           "name": "黃惠筠",
           "score": 21
        },
        {
           "name": "蔡凱紋",
           "score": 18
        }
     ]
  },
   {
     "team": "【Qisda】Run Run Run",
     "total": 80,
     "weight": 0,
     "members": [
        {
           "name": "陳婕婷",
           "score": 18
        },
        {
           "name": "陳榮耀",
           "score": 21
        },
        {
           "name": "陳季芊",
           "score": 18
        },
        {
           "name": "黃柏凱",
           "score": 12
        },
        {
           "name": "蘇煒智",
           "score": 11
        }
     ]
  },
   {
     "team": "【BenQ】S2B",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "陳正國",
           "score": 21
        },
        {
           "name": "蔡華駿",
           "score": 20
        },
        {
           "name": "林泰良",
           "score": 21
        },
        {
           "name": "郭峻豪",
           "score": 21
        },
        {
           "name": "吳孟純",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】Say me",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "宋佳齡",
           "score": 20
        },
        {
           "name": "馬維君",
           "score": 20
        },
        {
           "name": "廖韻涵",
           "score": 21
        },
        {
           "name": "鍾惠琴",
           "score": 21
        },
        {
           "name": "張家菱",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】So red",
     "total": 84,
     "weight": 0,
     "members": [
        {
           "name": "徐郡廷",
           "score": 19
        },
        {
           "name": "施穎臻",
           "score": 16
        },
        {
           "name": "鄭雅芝",
           "score": 15
        },
        {
           "name": "郭有斌",
           "score": 13
        },
        {
           "name": "陳芊毓",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】The Imports",
     "total": 39,
     "weight": 0,
     "members": [
        {
           "name": "Alon Lior",
           "score": 0
        },
        {
           "name": "莫柔娜",
           "score": 6
        },
        {
           "name": "藍聖杰",
           "score": 2
        },
        {
           "name": "Marek Wawr",
           "score": 20
        },
        {
           "name": "Szymon Bie",
           "score": 11
        }
     ]
  },
   {
     "team": "【Qisda】Walk from home",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "陳櫻方",
           "score": 21
        },
        {
           "name": "程鵬任",
           "score": 20
        },
        {
           "name": "葛宇婷",
           "score": 21
        },
        {
           "name": "劉亮妍",
           "score": 19
        },
        {
           "name": "陳俊廷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】Walking Men",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "張志鈞",
           "score": 18
        },
        {
           "name": "許俊昇",
           "score": 19
        },
        {
           "name": "陳萬暉",
           "score": 21
        },
        {
           "name": "蔡明諭",
           "score": 20
        },
        {
           "name": "戴宏宇",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】一定達標一定抽到我",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "張格銨",
           "score": 21
        },
        {
           "name": "蘇郁庭",
           "score": 21
        },
        {
           "name": "張以萱",
           "score": 21
        },
        {
           "name": "陳翔宥",
           "score": 21
        },
        {
           "name": "楊婷婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】一直走",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "陳雅慧",
           "score": 19
        },
        {
           "name": "曾鈺鈞",
           "score": 19
        },
        {
           "name": "謝玉娟",
           "score": 21
        },
        {
           "name": "蘇芳儀",
           "score": 21
        },
        {
           "name": "李帆",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】一起來減肥~~",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "邱瓊英",
           "score": 21
        },
        {
           "name": "錢卉菱",
           "score": 21
        },
        {
           "name": "郭承豪",
           "score": 21
        },
        {
           "name": "曾英誠",
           "score": 21
        },
        {
           "name": "黃秀琴",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】一起來運動",
     "total": 91,
     "weight": 0,
     "members": [
        {
           "name": "江芬梅",
           "score": 16
        },
        {
           "name": "林靖恒",
           "score": 21
        },
        {
           "name": "賴美妃",
           "score": 20
        },
        {
           "name": "林佳慧",
           "score": 18
        },
        {
           "name": "陳暄穎",
           "score": 16
        }
     ]
  },
   {
     "team": "【BenQ】一起運動吧~",
     "total": 63,
     "weight": 0,
     "members": [
        {
           "name": "林秋萍",
           "score": 12
        },
        {
           "name": "陳欣瑜",
           "score": 13
        },
        {
           "name": "黃怡芬",
           "score": 14
        },
        {
           "name": "鄭曉晴",
           "score": 11
        },
        {
           "name": "楊舒晴",
           "score": 13
        }
     ]
  },
   {
     "team": "【Qisda】一開賽就腳麻",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃樹蘭",
           "score": 21
        },
        {
           "name": "楊明恕",
           "score": 21
        },
        {
           "name": "葉蒼隆",
           "score": 21
        },
        {
           "name": "林誼妏",
           "score": 21
        },
        {
           "name": "徐玉玫",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】二樓守護者",
     "total": 45,
     "weight": 0,
     "members": [
        {
           "name": "何婉瑜",
           "score": 9
        },
        {
           "name": "吳郁璇",
           "score": 14
        },
        {
           "name": "林玉雯",
           "score": 15
        },
        {
           "name": "張道杰",
           "score": 0
        },
        {
           "name": "陳與聖",
           "score": 7
        }
     ]
  },
   {
     "team": "【Qisda】凡走過必留痕跡",
     "total": 89,
     "weight": 0,
     "members": [
        {
           "name": "李智勇",
           "score": 18
        },
        {
           "name": "簡雅卉",
           "score": 17
        },
        {
           "name": "廖俐萍",
           "score": 18
        },
        {
           "name": "陳宥叡",
           "score": 18
        },
        {
           "name": "陳莉君",
           "score": 18
        }
     ]
  },
   {
     "team": "【BenQ ESCO】大肚男愛運動",
     "total": 95,
     "weight": 0,
     "members": [
        {
           "name": "曾元鴻",
           "score": 19
        },
        {
           "name": "黃維宸",
           "score": 18
        },
        {
           "name": "楊永慶",
           "score": 20
        },
        {
           "name": "詹榮河",
           "score": 18
        },
        {
           "name": "劉明臻",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】大家動起來",
     "total": 95,
     "weight": 0,
     "members": [
        {
           "name": "簡榕嬅",
           "score": 14
        },
        {
           "name": "陳家淯",
           "score": 21
        },
        {
           "name": "傅昱瑋",
           "score": 19
        },
        {
           "name": "蔡玉嫈",
           "score": 20
        },
        {
           "name": "邱緯民",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】大健康",
     "total": 94,
     "weight": 0,
     "members": [
        {
           "name": "李曜任",
           "score": 17
        },
        {
           "name": "周忠良",
           "score": 20
        },
        {
           "name": "陳奇文",
           "score": 16
        },
        {
           "name": "陳俊欽",
           "score": 21
        },
        {
           "name": "陸明生",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】女神降臨動次動次",
     "total": 97,
     "weight": 0,
     "members": [
        {
           "name": "楊雅慧",
           "score": 19
        },
        {
           "name": "黃詩婷",
           "score": 20
        },
        {
           "name": "黃韻庭",
           "score": 19
        },
        {
           "name": "萬健吉",
           "score": 18
        },
        {
           "name": "簡玉雯",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】小熊隊",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "鄧國宏",
           "score": 21
        },
        {
           "name": "顏貽楨",
           "score": 21
        },
        {
           "name": "陳鈺娟",
           "score": 21
        },
        {
           "name": "林威",
           "score": 21
        },
        {
           "name": "鄭妤平",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】小豬跑起來",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "阮喬秋",
           "score": 21
        },
        {
           "name": "徐承志",
           "score": 16
        },
        {
           "name": "彭甲峯",
           "score": 21
        },
        {
           "name": "廖奕筑",
           "score": 21
        },
        {
           "name": "蔡明佑",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】不只要果汁機 我要筋膜槍",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃重裕",
           "score": 21
        },
        {
           "name": "王為令",
           "score": 21
        },
        {
           "name": "徐士婷",
           "score": 21
        },
        {
           "name": "劉韋吟",
           "score": 21
        },
        {
           "name": "劉燕玲",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】不要再撥放魔鬼中的天使算我求你了",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "王文慧",
           "score": 20
        },
        {
           "name": "鄭亦栴",
           "score": 20
        },
        {
           "name": "張筑茵",
           "score": 19
        },
        {
           "name": "胡瑋馨",
           "score": 21
        },
        {
           "name": "陳姵樺",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】不要給我壓力",
     "total": 97,
     "weight": 0,
     "members": [
        {
           "name": "江志芳",
           "score": 21
        },
        {
           "name": "李晴",
           "score": 16
        },
        {
           "name": "殷婉倫",
           "score": 20
        },
        {
           "name": "楊雅齡",
           "score": 19
        },
        {
           "name": "溫淑津",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】五千之呼吸",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "卓佑徽",
           "score": 21
        },
        {
           "name": "林政輝",
           "score": 21
        },
        {
           "name": "張志強",
           "score": 19
        },
        {
           "name": "周明慧",
           "score": 21
        },
        {
           "name": "游淑婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】五佰復仇戰",
     "total": 75,
     "weight": 0,
     "members": [
        {
           "name": "吳鎮宇",
           "score": 12
        },
        {
           "name": "張文駿",
           "score": 16
        },
        {
           "name": "王維廉",
           "score": 12
        },
        {
           "name": "陳佳琳",
           "score": 14
        },
        {
           "name": "劉家榮",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】今晚我想來點筋膜震槍",
     "total": 94,
     "weight": 0,
     "members": [
        {
           "name": "簡光宏",
           "score": 18
        },
        {
           "name": "王民遠",
           "score": 19
        },
        {
           "name": "王興賢",
           "score": 18
        },
        {
           "name": "李秉鴻",
           "score": 19
        },
        {
           "name": "黃泰融",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】內心暴風雪",
     "total": 66,
     "weight": 0,
     "members": [
        {
           "name": "江芊穎",
           "score": 11
        },
        {
           "name": "施淯婷",
           "score": 12
        },
        {
           "name": "張鳳羚",
           "score": 16
        },
        {
           "name": "楊晉源",
           "score": 20
        },
        {
           "name": "葉晉瑋",
           "score": 7
        }
     ]
  },
   {
     "team": "【Qisda】天天5,000戰勝體脂",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "黃莉雯",
           "score": 21
        },
        {
           "name": "何金源",
           "score": 19
        },
        {
           "name": "李文德",
           "score": 21
        },
        {
           "name": "黃原福",
           "score": 21
        },
        {
           "name": "李昌鴻",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】天天走走天天健康",
     "total": 88,
     "weight": 0,
     "members": [
        {
           "name": "賴建民",
           "score": 20
        },
        {
           "name": "李薇",
           "score": 15
        },
        {
           "name": "蔡欣恬",
           "score": 11
        },
        {
           "name": "王教馨",
           "score": 21
        },
        {
           "name": "林慧雯",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】天天運動身體好",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "何旭昇",
           "score": 21
        },
        {
           "name": "吳佳真",
           "score": 21
        },
        {
           "name": "李惠萍",
           "score": 21
        },
        {
           "name": "蘇偉銘",
           "score": 21
        },
        {
           "name": "林忠運",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】天竺鼠車車",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "林昭伶",
           "score": 21
        },
        {
           "name": "陳世和",
           "score": 21
        },
        {
           "name": "陳敬仁",
           "score": 20
        },
        {
           "name": "賴彥成",
           "score": 21
        },
        {
           "name": "許育銘",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】日日5000步, Hit Rate 100%",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "古珮嫻",
           "score": 20
        },
        {
           "name": "范曉梅",
           "score": 20
        },
        {
           "name": "張雅菁",
           "score": 21
        },
        {
           "name": "許心怡",
           "score": 20
        },
        {
           "name": "陳威廷",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】毛沒長齊就想走",
     "total": 91,
     "weight": 0,
     "members": [
        {
           "name": "周珮琪",
           "score": 20
        },
        {
           "name": "邵家怡",
           "score": 20
        },
        {
           "name": "陳又權",
           "score": 19
        },
        {
           "name": "黃子瑜",
           "score": 14
        },
        {
           "name": "黃晟豪",
           "score": 18
        }
     ]
  },
   {
     "team": "【BenQ】仙女海男",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "宋孟瑛",
           "score": 21
        },
        {
           "name": "陳賢凌",
           "score": 21
        },
        {
           "name": "陳蕙欣",
           "score": 21
        },
        {
           "name": "蔡駿毅",
           "score": 21
        },
        {
           "name": "楊斌",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】只想要果汁機",
     "total": 85,
     "weight": 0,
     "members": [
        {
           "name": "王薇寧",
           "score": 18
        },
        {
           "name": "白洧丞",
           "score": 17
        },
        {
           "name": "何若亞",
           "score": 16
        },
        {
           "name": "詹于萱",
           "score": 17
        },
        {
           "name": "謝玉淨",
           "score": 17
        }
     ]
  },
   {
     "team": "【Qisda】有緣無緣，大家走做伙",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "洪秋金",
           "score": 21
        },
        {
           "name": "林旺賜",
           "score": 21
        },
        {
           "name": "王立善",
           "score": 21
        },
        {
           "name": "黃士修",
           "score": 21
        },
        {
           "name": "吳榮華",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】肉衣掰掰囉",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "紀雅綺",
           "score": 21
        },
        {
           "name": "簡芝亭",
           "score": 21
        },
        {
           "name": "黃品華",
           "score": 18
        },
        {
           "name": "陳志嘉",
           "score": 20
        },
        {
           "name": "陳蔓怡",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】自由發揮",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "孫國華",
           "score": 20
        },
        {
           "name": "林智民",
           "score": 20
        },
        {
           "name": "徐瑞敏",
           "score": 21
        },
        {
           "name": "陳冠廷",
           "score": 21
        },
        {
           "name": "曾星澤",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】志在參加",
     "total": 94,
     "weight": 0,
     "members": [
        {
           "name": "曾向華",
           "score": 21
        },
        {
           "name": "倪瑞孜",
           "score": 21
        },
        {
           "name": "羅英萁",
           "score": 20
        },
        {
           "name": "吳相瑩",
           "score": 20
        },
        {
           "name": "洪巾嵐",
           "score": 12
        }
     ]
  },
   {
     "team": "【BenQ】我要出國玩",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "林君怡",
           "score": 21
        },
        {
           "name": "高慕悕",
           "score": 18
        },
        {
           "name": "邱怡君",
           "score": 21
        },
        {
           "name": "陳信伶",
           "score": 19
        },
        {
           "name": "陳怡如",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】我要打10個",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "邱素貞",
           "score": 21
        },
        {
           "name": "許立民",
           "score": 21
        },
        {
           "name": "蔡佳圻",
           "score": 21
        },
        {
           "name": "李訓賓",
           "score": 21
        },
        {
           "name": "徐崇禎",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】我要筋膜槍~~",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "劉佩欣",
           "score": 20
        },
        {
           "name": "曾佩珊",
           "score": 20
        },
        {
           "name": "林怡靚",
           "score": 21
        },
        {
           "name": "顏群宜",
           "score": 19
        },
        {
           "name": "林鉦翔",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】我要達成任務!",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "吳俊憲",
           "score": 21
        },
        {
           "name": "李育叡",
           "score": 21
        },
        {
           "name": "莊永勝",
           "score": 21
        },
        {
           "name": "連于雯",
           "score": 21
        },
        {
           "name": "鄭哲旻",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】我們決對沒有用走路神器",
     "total": 76,
     "weight": 0,
     "members": [
        {
           "name": "林盈君",
           "score": 14
        },
        {
           "name": "王智民",
           "score": 11
        },
        {
           "name": "侯燕棻",
           "score": 14
        },
        {
           "name": "楊宗峰",
           "score": 18
        },
        {
           "name": "蔡肇彥",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】我愛佳世達",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "吳家宏",
           "score": 21
        },
        {
           "name": "馬顗安",
           "score": 21
        },
        {
           "name": "曹昌雅",
           "score": 21
        },
        {
           "name": "黃明輝",
           "score": 21
        },
        {
           "name": "黃櫻華",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】走~走~走走走",
     "total": 68,
     "weight": 0,
     "members": [
        {
           "name": "林廷翊",
           "score": 17
        },
        {
           "name": "胡馨云",
           "score": 17
        },
        {
           "name": "張宇竣",
           "score": 15
        },
        {
           "name": "黃彥睿",
           "score": 15
        },
        {
           "name": "盧光恆",
           "score": 4
        }
     ]
  },
   {
     "team": "【Qisda】走走走 向前走",
     "total": 87,
     "weight": 0,
     "members": [
        {
           "name": "王御蓁",
           "score": 19
        },
        {
           "name": "陸文龍",
           "score": 19
        },
        {
           "name": "葉菁萍",
           "score": 15
        },
        {
           "name": "蘇莞琪",
           "score": 14
        },
        {
           "name": "謝民一",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】走到天荒地老",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "田孝怡",
           "score": 21
        },
        {
           "name": "梁麗梅",
           "score": 20
        },
        {
           "name": "陳寶如",
           "score": 19
        },
        {
           "name": "沈美禛",
           "score": 20
        },
        {
           "name": "莊業芬",
           "score": 12
        }
     ]
  },
   {
     "team": "【BenQ】走著走著就達標了",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "王凱俊",
           "score": 18
        },
        {
           "name": "李長昇",
           "score": 20
        },
        {
           "name": "張崇耀",
           "score": 21
        },
        {
           "name": "張嘉麟",
           "score": 21
        },
        {
           "name": "施嘉南",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】走路工",
     "total": 82,
     "weight": 0,
     "members": [
        {
           "name": "温芃安",
           "score": 16
        },
        {
           "name": "張哲倫",
           "score": 18
        },
        {
           "name": "陳婷婷",
           "score": 18
        },
        {
           "name": "陳彥翔",
           "score": 18
        },
        {
           "name": "林志仁",
           "score": 12
        }
     ]
  },
   {
     "team": "【BQP】走路王",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "林鈺斌",
           "score": 17
        },
        {
           "name": "秦若綺",
           "score": 19
        },
        {
           "name": "梁峻彬",
           "score": 16
        },
        {
           "name": "蕭雅婷",
           "score": 21
        },
        {
           "name": "曾瀠瑩",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】走路賺能量棒餵小芬",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "蔡昌泰",
           "score": 21
        },
        {
           "name": "黃怡豪",
           "score": 21
        },
        {
           "name": "黃承萱",
           "score": 21
        },
        {
           "name": "齊靖之",
           "score": 21
        },
        {
           "name": "劉珊滇",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】車用加油～",
     "total": 77,
     "weight": 0,
     "members": [
        {
           "name": "方國誌",
           "score": 19
        },
        {
           "name": "葉哲均",
           "score": 16
        },
        {
           "name": "林岱寰",
           "score": 6
        },
        {
           "name": "莊錦文",
           "score": 17
        },
        {
           "name": "陳芋臣",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】車用跑得快",
     "total": 78,
     "weight": 0,
     "members": [
        {
           "name": "李念嬫",
           "score": 12
        },
        {
           "name": "陳雙穩",
           "score": 18
        },
        {
           "name": "劉麗娟",
           "score": 18
        },
        {
           "name": "鄭雅云",
           "score": 16
        },
        {
           "name": "林陽貿",
           "score": 14
        }
     ]
  },
   {
     "team": "【BQP】亞太走路工",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "張晴菱",
           "score": 21
        },
        {
           "name": "薛雅文",
           "score": 21
        },
        {
           "name": "邱琬珺",
           "score": 21
        },
        {
           "name": "陳立翰",
           "score": 20
        },
        {
           "name": "陳亭伊",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】來去暖戰Young一下",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "陳春樺",
           "score": 20
        },
        {
           "name": "張亞殷",
           "score": 21
        },
        {
           "name": "陳俊錫",
           "score": 19
        },
        {
           "name": "謝其昌",
           "score": 21
        },
        {
           "name": "賴美如",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】委員長向前衝",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "王啟鑫",
           "score": 21
        },
        {
           "name": "鄭仰修",
           "score": 21
        },
        {
           "name": "柯力文",
           "score": 21
        },
        {
           "name": "洪斌修",
           "score": 21
        },
        {
           "name": "郭舒硯",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】姐就是美",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "梁翠玲",
           "score": 21
        },
        {
           "name": "陳蕙薰",
           "score": 21
        },
        {
           "name": "王儀婷",
           "score": 21
        },
        {
           "name": "蕭沛蓁",
           "score": 21
        },
        {
           "name": "張美琪",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】抽中筋模槍",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "宋旻儀",
           "score": 21
        },
        {
           "name": "林素娥",
           "score": 21
        },
        {
           "name": "陳錦紋",
           "score": 21
        },
        {
           "name": "陸佩蘭",
           "score": 21
        },
        {
           "name": "劉永清",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】明基黑客松",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "蔡宜蓁",
           "score": 21
        },
        {
           "name": "王崇任",
           "score": 21
        },
        {
           "name": "林延駿",
           "score": 21
        },
        {
           "name": "劉芳妤",
           "score": 21
        },
        {
           "name": "蘇育瑤",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】阿忠哥就是腰瘦",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "陳威州",
           "score": 20
        },
        {
           "name": "陳榮貴",
           "score": 20
        },
        {
           "name": "楊秉忠",
           "score": 21
        },
        {
           "name": "劉邦宏",
           "score": 21
        },
        {
           "name": "郭民安",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】阿基獅跑跑!",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "余弘翔",
           "score": 21
        },
        {
           "name": "吳柔萱",
           "score": 21
        },
        {
           "name": "馮信璁",
           "score": 21
        },
        {
           "name": "黃健哲",
           "score": 21
        },
        {
           "name": "鍾委璋",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】青壯隊",
     "total": 88,
     "weight": 0,
     "members": [
        {
           "name": "吳志祥",
           "score": 17
        },
        {
           "name": "姚宏民",
           "score": 21
        },
        {
           "name": "黃慶鐘",
           "score": 17
        },
        {
           "name": "鄒慶穎",
           "score": 21
        },
        {
           "name": "簡立翔",
           "score": 12
        }
     ]
  },
   {
     "team": "【Qisda】青春美麗",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "王俞智",
           "score": 21
        },
        {
           "name": "呂映儒",
           "score": 21
        },
        {
           "name": "林怡君",
           "score": 21
        },
        {
           "name": "張美瑤",
           "score": 21
        },
        {
           "name": "陳渝鈞",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】青春隨風飄搖",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "吳彩雲",
           "score": 21
        },
        {
           "name": "洪喜音",
           "score": 21
        },
        {
           "name": "莊舒萍",
           "score": 21
        },
        {
           "name": "連政南",
           "score": 21
        },
        {
           "name": "葛定寰",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】前面的都瘋了對不隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "何昭緯",
           "score": 21
        },
        {
           "name": "黃敏利",
           "score": 21
        },
        {
           "name": "蕭宇雯",
           "score": 21
        },
        {
           "name": "謝艾靜",
           "score": 21
        },
        {
           "name": "魏章如",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】按摩槍我來了~",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "呂東科",
           "score": 17
        },
        {
           "name": "凃建明",
           "score": 20
        },
        {
           "name": "張登任",
           "score": 21
        },
        {
           "name": "陳君輔",
           "score": 21
        },
        {
           "name": "吳志鴻",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】為了你",
     "total": 91,
     "weight": 0,
     "members": [
        {
           "name": "王靜慧",
           "score": 17
        },
        {
           "name": "林彥村",
           "score": 20
        },
        {
           "name": "詹宏智",
           "score": 20
        },
        {
           "name": "李宗熹",
           "score": 19
        },
        {
           "name": "胡志銘",
           "score": 15
        }
     ]
  },
   {
     "team": "【BenQ】為鳳梨加油!!",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林雙喜",
           "score": 21
        },
        {
           "name": "蔡宏奇",
           "score": 21
        },
        {
           "name": "林君翰",
           "score": 21
        },
        {
           "name": "陳盈佐",
           "score": 21
        },
        {
           "name": "蔡孟珊",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】要活就要動 - 我要筋膜震槍",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "方愛玲",
           "score": 21
        },
        {
           "name": "古威揚",
           "score": 21
        },
        {
           "name": "游健忠",
           "score": 21
        },
        {
           "name": "廖啟村",
           "score": 21
        },
        {
           "name": "虞美雲",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】音速玩起來",
     "total": 62,
     "weight": 0,
     "members": [
        {
           "name": "林家馨",
           "score": 19
        },
        {
           "name": "林詩婷",
           "score": 0
        },
        {
           "name": "洪愷均",
           "score": 17
        },
        {
           "name": "黃柏程",
           "score": 18
        },
        {
           "name": "蔡婷宇",
           "score": 8
        }
     ]
  },
   {
     "team": "【Qisda】音速追起來",
     "total": 66,
     "weight": 0,
     "members": [
        {
           "name": "呂鈺心",
           "score": 10
        },
        {
           "name": "林峰舟",
           "score": 21
        },
        {
           "name": "黃建國",
           "score": 12
        },
        {
           "name": "黃思華",
           "score": 11
        },
        {
           "name": "鍾愛",
           "score": 12
        }
     ]
  },
   {
     "team": "【Qisda】音速動起來",
     "total": 76,
     "weight": 0,
     "members": [
        {
           "name": "翁禎廷",
           "score": 8
        },
        {
           "name": "蘇哲瑋",
           "score": 10
        },
        {
           "name": "陳文暐",
           "score": 21
        },
        {
           "name": "李明泰",
           "score": 21
        },
        {
           "name": "柯雅萍",
           "score": 16
        }
     ]
  },
   {
     "team": "【Qisda】音速跑起來",
     "total": 98,
     "weight": 0,
     "members": [
        {
           "name": "劉芳斌",
           "score": 20
        },
        {
           "name": "李世裕",
           "score": 21
        },
        {
           "name": "姚錦樹",
           "score": 21
        },
        {
           "name": "劉秉洋",
           "score": 21
        },
        {
           "name": "杜昆鴻",
           "score": 15
        }
     ]
  },
   {
     "team": "【Qisda】音速跳起來",
     "total": 89,
     "weight": 0,
     "members": [
        {
           "name": "莊佳恩",
           "score": 20
        },
        {
           "name": "蔡志佳",
           "score": 18
        },
        {
           "name": "李冠儒",
           "score": 21
        },
        {
           "name": "沈佳瑩",
           "score": 14
        },
        {
           "name": "蕭瑋廷",
           "score": 16
        }
     ]
  },
   {
     "team": "【Qisda】風怎麼吹我管不著",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "施泰安",
           "score": 21
        },
        {
           "name": "梁淑惠",
           "score": 21
        },
        {
           "name": "陳正榮",
           "score": 21
        },
        {
           "name": "蕭蕙瑩",
           "score": 21
        },
        {
           "name": "簡秀倩",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】原班人馬",
     "total": 95,
     "weight": 0,
     "members": [
        {
           "name": "李英嘉",
           "score": 19
        },
        {
           "name": "林筱芸",
           "score": 21
        },
        {
           "name": "徐瑞陽",
           "score": 21
        },
        {
           "name": "徐梅閨",
           "score": 15
        },
        {
           "name": "謝妤盈",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】哥就是帥",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "周曜堂",
           "score": 21
        },
        {
           "name": "張喻涵",
           "score": 21
        },
        {
           "name": "詹庭歡",
           "score": 21
        },
        {
           "name": "林佳芳",
           "score": 21
        },
        {
           "name": "蕭宛琪",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】神偷奶爸",
     "total": 87,
     "weight": 0,
     "members": [
        {
           "name": "呂亮圻",
           "score": 17
        },
        {
           "name": "孫靜瀅",
           "score": 21
        },
        {
           "name": "張芳樺",
           "score": 18
        },
        {
           "name": "陳俞蓁",
           "score": 13
        },
        {
           "name": "簡大為",
           "score": 18
        }
     ]
  },
   {
     "team": "【Qisda】神腳*肉腳組",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "吳素菁",
           "score": 20
        },
        {
           "name": "游慧琪",
           "score": 21
        },
        {
           "name": "黃婉芬",
           "score": 21
        },
        {
           "name": "陳怡伶",
           "score": 21
        },
        {
           "name": "黃郁倫",
           "score": 17
        }
     ]
  },
   {
     "team": "【Qisda】脂滅殺肥隊",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "伍菁媚",
           "score": 21
        },
        {
           "name": "林芳百",
           "score": 21
        },
        {
           "name": "黃湘綺",
           "score": 20
        },
        {
           "name": "李昀臻",
           "score": 21
        },
        {
           "name": "連育誼",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】偷懶罰500",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "林孝誠",
           "score": 20
        },
        {
           "name": "黃良吉",
           "score": 21
        },
        {
           "name": "楊錦文",
           "score": 20
        },
        {
           "name": "張順富",
           "score": 19
        },
        {
           "name": "余珍瑩",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】動滋小姐",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "李如玉",
           "score": 21
        },
        {
           "name": "張歆安",
           "score": 21
        },
        {
           "name": "陳怡帆",
           "score": 17
        },
        {
           "name": "陳慧珠",
           "score": 21
        },
        {
           "name": "蔡宴芸",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】悠閒生活",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "王博文",
           "score": 20
        },
        {
           "name": "徐聖堯",
           "score": 21
        },
        {
           "name": "陳鈞瑋",
           "score": 21
        },
        {
           "name": "廖浚瑋",
           "score": 21
        },
        {
           "name": "蔡志浩",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】軟爛跑跑人",
     "total": 98,
     "weight": 0,
     "members": [
        {
           "name": "陳怡廷",
           "score": 20
        },
        {
           "name": "孫健恆",
           "score": 19
        },
        {
           "name": "黃思婕",
           "score": 18
        },
        {
           "name": "李育瑩",
           "score": 21
        },
        {
           "name": "廖雅平",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】造甘那盃",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "湯硯程",
           "score": 20
        },
        {
           "name": "龔又嫻",
           "score": 20
        },
        {
           "name": "徐維文",
           "score": 21
        },
        {
           "name": "陳俐吟",
           "score": 20
        },
        {
           "name": "陳筱涵",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】最強肉體",
     "total": 96,
     "weight": 0,
     "members": [
        {
           "name": "江聖哲",
           "score": 17
        },
        {
           "name": "李坤城",
           "score": 20
        },
        {
           "name": "張志豪",
           "score": 21
        },
        {
           "name": "項石民",
           "score": 20
        },
        {
           "name": "簡弘璋",
           "score": 18
        }
     ]
  },
   {
     "team": "【Qisda】富蘭克林",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "李依真",
           "score": 21
        },
        {
           "name": "張智鈞",
           "score": 20
        },
        {
           "name": "許富順",
           "score": 21
        },
        {
           "name": "游志鴻",
           "score": 21
        },
        {
           "name": "林賢峰",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】就是這一隊",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "孫沁琳",
           "score": 21
        },
        {
           "name": "楊芝郡",
           "score": 15
        },
        {
           "name": "周衣絜",
           "score": 20
        },
        {
           "name": "林盈甄",
           "score": 16
        },
        {
           "name": "郭宇媃",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】散散步~",
     "total": 80,
     "weight": 0,
     "members": [
        {
           "name": "施仲生",
           "score": 21
        },
        {
           "name": "王啟典",
           "score": 6
        },
        {
           "name": "石博宇",
           "score": 21
        },
        {
           "name": "廖祥瑞",
           "score": 11
        },
        {
           "name": "駱振瑞",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】筋D膜C震C槍3",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "李明倫",
           "score": 20
        },
        {
           "name": "林宇浩",
           "score": 21
        },
        {
           "name": "楊宗諺",
           "score": 21
        },
        {
           "name": "靳開翔",
           "score": 21
        },
        {
           "name": "賴威丞",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】筋膜槍是我的對不",
     "total": 89,
     "weight": 0,
     "members": [
        {
           "name": "何瑋琳",
           "score": 10
        },
        {
           "name": "吳宗祐",
           "score": 20
        },
        {
           "name": "陳瑩娌",
           "score": 20
        },
        {
           "name": "鄭景尤",
           "score": 19
        },
        {
           "name": "曾凱暐",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】筋膜槍謝謝",
     "total": 93,
     "weight": 0,
     "members": [
        {
           "name": "黃于穎",
           "score": 21
        },
        {
           "name": "黃郁茹",
           "score": 16
        },
        {
           "name": "趙盈慧",
           "score": 21
        },
        {
           "name": "鄭雅雯",
           "score": 21
        },
        {
           "name": "闕孝睿",
           "score": 14
        }
     ]
  },
   {
     "team": "【BenQ】筋膜槍還我漂漂拳",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "王詩涵",
           "score": 21
        },
        {
           "name": "陳亭瑄",
           "score": 20
        },
        {
           "name": "黃怡嘉",
           "score": 21
        },
        {
           "name": "劉昱蓁",
           "score": 21
        },
        {
           "name": "蔡采吟",
           "score": 20
        }
     ]
  },
   {
     "team": "【BenQ】給我禮券就好",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "李珮慈",
           "score": 21
        },
        {
           "name": "賴柏尹",
           "score": 21
        },
        {
           "name": "宋長翰",
           "score": 21
        },
        {
           "name": "江進富",
           "score": 21
        },
        {
           "name": "李志文",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】超前走走走",
     "total": 93,
     "weight": 0,
     "members": [
        {
           "name": "吳文明",
           "score": 12
        },
        {
           "name": "柯淑芬",
           "score": 21
        },
        {
           "name": "陳雍松",
           "score": 19
        },
        {
           "name": "歐家興",
           "score": 21
        },
        {
           "name": "蔡瑩諭",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】跑跑跑,向前跑",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "柳碧秋",
           "score": 21
        },
        {
           "name": "沈淑娥",
           "score": 21
        },
        {
           "name": "胡月娥",
           "score": 19
        },
        {
           "name": "彭美玲",
           "score": 21
        },
        {
           "name": "蘇秀雲",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】隊名很難想耶",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "白逸禾",
           "score": 21
        },
        {
           "name": "陳秋萍",
           "score": 21
        },
        {
           "name": "黃國榮",
           "score": 21
        },
        {
           "name": "胡智堯",
           "score": 21
        },
        {
           "name": "張志家",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】搖起來",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "丁正偉",
           "score": 21
        },
        {
           "name": "宋昭利",
           "score": 19
        },
        {
           "name": "周芳如",
           "score": 19
        },
        {
           "name": "許慧正",
           "score": 20
        },
        {
           "name": "楊惠婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】準備拿獎品隊",
     "total": 77,
     "weight": 0,
     "members": [
        {
           "name": "朱立貴",
           "score": 2
        },
        {
           "name": "林炯安",
           "score": 17
        },
        {
           "name": "林鴻文",
           "score": 21
        },
        {
           "name": "許旻傑",
           "score": 20
        },
        {
           "name": "陳昭宏",
           "score": 17
        }
     ]
  },
   {
     "team": "【BenQ】煞氣a走路隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林信男",
           "score": 21
        },
        {
           "name": "黃晉初",
           "score": 21
        },
        {
           "name": "朱晟維",
           "score": 21
        },
        {
           "name": "陳冠翰",
           "score": 21
        },
        {
           "name": "歐柔倩",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】禁止互相傷害",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "邱怡雯",
           "score": 21
        },
        {
           "name": "夏美珍",
           "score": 21
        },
        {
           "name": "黃嘉華",
           "score": 21
        },
        {
           "name": "廖振寧",
           "score": 21
        },
        {
           "name": "蔡宗民",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】資管之王",
     "total": 90,
     "weight": 0,
     "members": [
        {
           "name": "王敬順",
           "score": 16
        },
        {
           "name": "田喆",
           "score": 20
        },
        {
           "name": "林家安",
           "score": 21
        },
        {
           "name": "邱欣筠",
           "score": 20
        },
        {
           "name": "謝享叡",
           "score": 13
        }
     ]
  },
   {
     "team": "【Qisda】賈洨配胖",
     "total": 96,
     "weight": 0,
     "members": [
        {
           "name": "林士凱",
           "score": 19
        },
        {
           "name": "林祐羽",
           "score": 20
        },
        {
           "name": "林詠智",
           "score": 20
        },
        {
           "name": "張文雯",
           "score": 20
        },
        {
           "name": "陳俊雄",
           "score": 17
        }
     ]
  },
   {
     "team": "【Qisda】運動完喝草莓芝芝",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "劉書吟",
           "score": 20
        },
        {
           "name": "王羚真",
           "score": 21
        },
        {
           "name": "呂莉萍",
           "score": 21
        },
        {
           "name": "廖慧芳",
           "score": 20
        },
        {
           "name": "許雅婷",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】認真來健走，不雷我隊友",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "陳其宏",
           "score": 21
        },
        {
           "name": "黃漢州",
           "score": 21
        },
        {
           "name": "薛道隆",
           "score": 20
        },
        {
           "name": "楊宏培",
           "score": 21
        },
        {
           "name": "黃文芳",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】輕輕鬆鬆",
     "total": 88,
     "weight": 0,
     "members": [
        {
           "name": "陳仲豪",
           "score": 15
        },
        {
           "name": "彭濬杰",
           "score": 20
        },
        {
           "name": "張瓊文",
           "score": 17
        },
        {
           "name": "孫蘇琴",
           "score": 16
        },
        {
           "name": "陳清洲",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】輕鬆跑",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "劉育昌",
           "score": 15
        },
        {
           "name": "江芳君",
           "score": 20
        },
        {
           "name": "林柏丞",
           "score": 19
        },
        {
           "name": "張翔任",
           "score": 20
        },
        {
           "name": "葉志發",
           "score": 18
        }
     ]
  },
   {
     "team": "【BenQ】獎項很遺憾",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "郭孝儀",
           "score": 21
        },
        {
           "name": "葉庭瑋",
           "score": 21
        },
        {
           "name": "賴宥羽",
           "score": 21
        },
        {
           "name": "吳韋良",
           "score": 21
        },
        {
           "name": "許家豪",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】衝....",
     "total": 83,
     "weight": 0,
     "members": [
        {
           "name": "張智明",
           "score": 18
        },
        {
           "name": "邱顯竹",
           "score": 17
        },
        {
           "name": "林建宏",
           "score": 16
        },
        {
           "name": "徐子桓",
           "score": 12
        },
        {
           "name": "江建誼",
           "score": 20
        }
     ]
  },
   {
     "team": "【Qisda】衝不停隊",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "李秀玉",
           "score": 21
        },
        {
           "name": "徐佩玉",
           "score": 20
        },
        {
           "name": "陳景芳",
           "score": 21
        },
        {
           "name": "陳意絜",
           "score": 21
        },
        {
           "name": "蔡珍兒",
           "score": 19
        }
     ]
  },
   {
     "team": "【BQP】衝衝衝",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "張沁穎",
           "score": 21
        },
        {
           "name": "林碩鶴",
           "score": 20
        },
        {
           "name": "廖惠貞",
           "score": 21
        },
        {
           "name": "王佳韻",
           "score": 21
        },
        {
           "name": "陳恬瑩",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】請不要跟我作隊",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "徐嘉諄",
           "score": 21
        },
        {
           "name": "宋建緯",
           "score": 21
        },
        {
           "name": "林建銘",
           "score": 20
        },
        {
           "name": "張芳瑜",
           "score": 21
        },
        {
           "name": "楊鎰鍵",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】激情飛揚，超越自我",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "梁憲忠",
           "score": 21
        },
        {
           "name": "張皎潔",
           "score": 21
        },
        {
           "name": "何民英",
           "score": 20
        },
        {
           "name": "陳文江",
           "score": 21
        },
        {
           "name": "魏玉春",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】謝了，戴我崇左吟走回嘉",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "葉崇文",
           "score": 21
        },
        {
           "name": "謝承志",
           "score": 21
        },
        {
           "name": "郭亭吟",
           "score": 21
        },
        {
           "name": "陳昱嘉",
           "score": 21
        },
        {
           "name": "戴張戎",
           "score": 21
        }
     ]
  },
   {
     "team": "【Qisda】醫療團隊讚",
     "total": 81,
     "weight": 0,
     "members": [
        {
           "name": "李惠娜",
           "score": 18
        },
        {
           "name": "賈凱憶",
           "score": 10
        },
        {
           "name": "李俊緯",
           "score": 21
        },
        {
           "name": "張庭瑜",
           "score": 18
        },
        {
           "name": "楊思齊",
           "score": 14
        }
     ]
  },
   {
     "team": "【BQP】寶飽跑",
     "total": 98,
     "weight": 0,
     "members": [
        {
           "name": "陳柏文",
           "score": 17
        },
        {
           "name": "賈乃欣",
           "score": 20
        },
        {
           "name": "陳薏婷",
           "score": 21
        },
        {
           "name": "秦國超",
           "score": 21
        },
        {
           "name": "陳永翰",
           "score": 19
        }
     ]
  },
   {
     "team": "【Qisda】蘿蔔產銷班",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃宇濤",
           "score": 21
        },
        {
           "name": "林志遠",
           "score": 21
        },
        {
           "name": "簡碩良",
           "score": 21
        },
        {
           "name": "吳桑喬",
           "score": 21
        },
        {
           "name": "曾美惠",
           "score": 21
        }
     ]
  },
   {
     "team": "【BenQ】頭好壯壯隊",
     "total": 97,
     "weight": 0,
     "members": [
        {
           "name": "許心瑩",
           "score": 21
        },
        {
           "name": "陳彥華",
           "score": 21
        },
        {
           "name": "許湘庭",
           "score": 15
        },
        {
           "name": "王麗貴",
           "score": 21
        },
        {
           "name": "黃韻蓉",
           "score": 19
        }
     ]
  },
   {
     "team": "【明泰】PID趴趴走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "許淑珍",
           "score": 21
        },
        {
           "name": "吳昕晏",
           "score": 21
        },
        {
           "name": "李燕菁",
           "score": 21
        },
        {
           "name": "黃相敏",
           "score": 21
        },
        {
           "name": "鍾佳燕",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】再不運動就會胖",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "曾苑菱",
           "score": 21
        },
        {
           "name": "楊玲佳",
           "score": 21
        },
        {
           "name": "崔夢婷",
           "score": 21
        },
        {
           "name": "林詩展",
           "score": 21
        },
        {
           "name": "朱宏欽",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】贏我就不隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "梁澤真",
           "score": 21
        },
        {
           "name": "鍾健偉",
           "score": 21
        },
        {
           "name": "林士傑",
           "score": 21
        },
        {
           "name": "吳雲慶",
           "score": 21
        },
        {
           "name": "魏兆辰",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】女神說的隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "吳青燁",
           "score": 21
        },
        {
           "name": "李昕蓉",
           "score": 21
        },
        {
           "name": "張昭瑩",
           "score": 21
        },
        {
           "name": "陳慧娟",
           "score": 21
        },
        {
           "name": "林蘭心",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】拉拉隊",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "鄭嘉慶",
           "score": 21
        },
        {
           "name": "洪素禎",
           "score": 21
        },
        {
           "name": "蔡佳如",
           "score": 20
        },
        {
           "name": "陳羿汶",
           "score": 21
        },
        {
           "name": "徐志宏",
           "score": 21
        }
     ]
  },
   {
     "team": "【明泰】走就隊",
     "total": 97,
     "weight": 0,
     "members": [
        {
           "name": "許皓雅",
           "score": 19
        },
        {
           "name": "陳佳琳",
           "score": 20
        },
        {
           "name": "陳芳琴",
           "score": 18
        },
        {
           "name": "林劭芸",
           "score": 21
        },
        {
           "name": "葉亭玟",
           "score": 19
        }
     ]
  },
   {
     "team": "【互動】佛系達標隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "曾宗婷",
           "score": 21
        },
        {
           "name": "陳麗君",
           "score": 21
        },
        {
           "name": "丁碧霞",
           "score": 21
        },
        {
           "name": "黃迪農",
           "score": 21
        },
        {
           "name": "賴奕銓",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】陶冶森心隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林詩敏",
           "score": 21
        },
        {
           "name": "許詩慧",
           "score": 21
        },
        {
           "name": "林孜珊",
           "score": 21
        },
        {
           "name": "賴宣羽",
           "score": 21
        },
        {
           "name": "蘇雅蘭",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】決戰105",
     "total": 93,
     "weight": 0,
     "members": [
        {
           "name": "陳昆濬",
           "score": 19
        },
        {
           "name": "陳秋如",
           "score": 20
        },
        {
           "name": "柯永慶",
           "score": 19
        },
        {
           "name": "邱景政",
           "score": 14
        },
        {
           "name": "梁憲平",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】動次動",
     "total": 96,
     "weight": 0,
     "members": [
        {
           "name": "賴揚義",
           "score": 20
        },
        {
           "name": "張世謀",
           "score": 17
        },
        {
           "name": "蘇明哲",
           "score": 19
        },
        {
           "name": "丘振誠",
           "score": 21
        },
        {
           "name": "劉獻中",
           "score": 19
        }
     ]
  },
   {
     "team": "【互動】互動工程後衛隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "張順誠",
           "score": 21
        },
        {
           "name": "陳建宏",
           "score": 21
        },
        {
           "name": "黃漢輝",
           "score": 21
        },
        {
           "name": "黃美智",
           "score": 21
        },
        {
           "name": "張芮瑋",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】步步高升隊",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "吳佳穎",
           "score": 20
        },
        {
           "name": "王瑋鈴",
           "score": 21
        },
        {
           "name": "張立君",
           "score": 21
        },
        {
           "name": "蔡宸豐",
           "score": 21
        },
        {
           "name": "王紹穎",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】互動冠軍一號",
     "total": 87,
     "weight": 0,
     "members": [
        {
           "name": "陳啟川",
           "score": 20
        },
        {
           "name": "劉威廷",
           "score": 17
        },
        {
           "name": "黃健忠",
           "score": 18
        },
        {
           "name": "甘裕民",
           "score": 17
        },
        {
           "name": "林維綱",
           "score": 15
        }
     ]
  },
   {
     "team": "【互動】天竺鼠車車",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "羅偉愿",
           "score": 20
        },
        {
           "name": "廖儷雪",
           "score": 18
        },
        {
           "name": "傅婉菁",
           "score": 20
        },
        {
           "name": "王如梅",
           "score": 21
        },
        {
           "name": "簡嘉賢",
           "score": 21
        }
     ]
  },
   {
     "team": "【互動】互動冠軍(高階主管)",
     "total": 94,
     "weight": 0,
     "members": [
        {
           "name": "吳耀庭",
           "score": 20
        },
        {
           "name": "陳美琪",
           "score": 18
        },
        {
           "name": "李峰如",
           "score": 21
        },
        {
           "name": "張恩霖",
           "score": 19
        },
        {
           "name": "徐堂傑",
           "score": 16
        }
     ]
  },
   {
     "team": "【仲琦】四樓顏值擔當",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林柏守",
           "score": 21
        },
        {
           "name": "林欽漢",
           "score": 21
        },
        {
           "name": "葉怡賢",
           "score": 21
        },
        {
           "name": "林聖璋",
           "score": 21
        },
        {
           "name": "王珮玲",
           "score": 21
        }
     ]
  },
   {
     "team": "【仲琦】HappyFeet",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "曹芝君",
           "score": 21
        },
        {
           "name": "孫若盈",
           "score": 21
        },
        {
           "name": "潘查卡",
           "score": 21
        },
        {
           "name": "賴光仲",
           "score": 21
        },
        {
           "name": "許惠琪",
           "score": 21
        }
     ]
  },
   {
     "team": "【仲琦】一琦去散步",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "陳冠璋",
           "score": 21
        },
        {
           "name": "陳梅君",
           "score": 21
        },
        {
           "name": "黃昱翔",
           "score": 21
        },
        {
           "name": "吳其甄",
           "score": 21
        },
        {
           "name": "蕭昰驊",
           "score": 21
        }
     ]
  },
   {
     "team": "【仲琦】最強之我們一起走",
     "total": 82,
     "weight": 0,
     "members": [
        {
           "name": "徐聖添",
           "score": 10
        },
        {
           "name": "劉子庭",
           "score": 11
        },
        {
           "name": "陳君瑋",
           "score": 21
        },
        {
           "name": "羅桂琴",
           "score": 20
        },
        {
           "name": "陳佳昇",
           "score": 20
        }
     ]
  },
   {
     "team": "【仲琦】仲所矚目",
     "total": 87,
     "weight": 0,
     "members": [
        {
           "name": "劉美蘭",
           "score": 10
        },
        {
           "name": "邱培舜",
           "score": 19
        },
        {
           "name": "許裕發",
           "score": 20
        },
        {
           "name": "蔣尚義",
           "score": 21
        },
        {
           "name": "翁溓松",
           "score": 17
        }
     ]
  },
   {
     "team": "【仲琦】1798",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "林伶娟",
           "score": 20
        },
        {
           "name": "孔德榮",
           "score": 21
        },
        {
           "name": "李佩芬",
           "score": 21
        },
        {
           "name": "陳龍美",
           "score": 21
        },
        {
           "name": "林靜君",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】犇跑吧2021",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "蔡其南",
           "score": 20
        },
        {
           "name": "黃麗敏",
           "score": 21
        },
        {
           "name": "張家益",
           "score": 21
        },
        {
           "name": "吳羅龍",
           "score": 21
        },
        {
           "name": "田芝穎",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】趴趴走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "蔣孟燕",
           "score": 21
        },
        {
           "name": "林湘婷",
           "score": 21
        },
        {
           "name": "蔣婷安",
           "score": 21
        },
        {
           "name": "游詒軫",
           "score": 21
        },
        {
           "name": "劉芸希",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】粗來面隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "鍾育陞",
           "score": 21
        },
        {
           "name": "蘇怡萍",
           "score": 21
        },
        {
           "name": "巫宜恬",
           "score": 21
        },
        {
           "name": "張蓓茹",
           "score": 21
        },
        {
           "name": "李佳珍",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】遠走高飛隊",
     "total": 93,
     "weight": 0,
     "members": [
        {
           "name": "張子祐",
           "score": 20
        },
        {
           "name": "呂孟融",
           "score": 18
        },
        {
           "name": "蘇金玄",
           "score": 20
        },
        {
           "name": "楊方奇",
           "score": 15
        },
        {
           "name": "蔡逸民",
           "score": 20
        }
     ]
  },
   {
     "team": "【DFI】復仇者聯盟隊",
     "total": 67,
     "weight": 0,
     "members": [
        {
           "name": "林欣璋",
           "score": 20
        },
        {
           "name": "邱晟豪",
           "score": 6
        },
        {
           "name": "楊翔皓",
           "score": 2
        },
        {
           "name": "游建明",
           "score": 20
        },
        {
           "name": "葉珈宏",
           "score": 19
        }
     ]
  },
   {
     "team": "【DFI】輕鬆走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃瓊儀",
           "score": 21
        },
        {
           "name": "温珮婕",
           "score": 21
        },
        {
           "name": "黃育純",
           "score": 21
        },
        {
           "name": "黃友志",
           "score": 21
        },
        {
           "name": "王又平",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】管我走不走！",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "余奕萱",
           "score": 21
        },
        {
           "name": "楊愷伶",
           "score": 21
        },
        {
           "name": "張家倫",
           "score": 21
        },
        {
           "name": "黃珮萱",
           "score": 21
        },
        {
           "name": "蔡佳佳",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】要活就要動",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "陳志民",
           "score": 20
        },
        {
           "name": "陳銘遠",
           "score": 21
        },
        {
           "name": "黃奎元",
           "score": 21
        },
        {
           "name": "張峰銘",
           "score": 21
        },
        {
           "name": "石育麟",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】慢活噢杯Run",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "吳宥諭",
           "score": 20
        },
        {
           "name": "黃考明",
           "score": 21
        },
        {
           "name": "方信雄",
           "score": 21
        },
        {
           "name": "吳葉元",
           "score": 21
        },
        {
           "name": "洪郁雯",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】說走就走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃雅君",
           "score": 21
        },
        {
           "name": "李怡玫",
           "score": 21
        },
        {
           "name": "林幸宜",
           "score": 21
        },
        {
           "name": "吳繼茹",
           "score": 21
        },
        {
           "name": "謝君婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】衝衝衝!",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "陳松偉",
           "score": 21
        },
        {
           "name": "王皓昱",
           "score": 21
        },
        {
           "name": "潘培仁",
           "score": 21
        },
        {
           "name": "廖喜玲",
           "score": 21
        },
        {
           "name": "周享明",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】哪次不走",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "曾詠智",
           "score": 21
        },
        {
           "name": "楊政憲",
           "score": 21
        },
        {
           "name": "胡佳隆",
           "score": 20
        },
        {
           "name": "陳宗翰",
           "score": 21
        },
        {
           "name": "黃潤德",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】Key層走路",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "施韋任",
           "score": 21
        },
        {
           "name": "林曼資",
           "score": 21
        },
        {
           "name": "陳盈君",
           "score": 21
        },
        {
           "name": "葉子榕",
           "score": 21
        },
        {
           "name": "詹雅婷",
           "score": 21
        }
     ]
  },
   {
     "team": "【DFI】鋼鐵軟體人",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "羅育軒",
           "score": 21
        },
        {
           "name": "林孛翰",
           "score": 21
        },
        {
           "name": "楊崇正",
           "score": 21
        },
        {
           "name": "黃雲璘",
           "score": 21
        },
        {
           "name": "涂志豪",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】小房間瘦瘦",
     "total": 69,
     "weight": 0,
     "members": [
        {
           "name": "姜星宇",
           "score": 14
        },
        {
           "name": "周士涵",
           "score": 16
        },
        {
           "name": "劉宇倫",
           "score": 11
        },
        {
           "name": "肯畢娜",
           "score": 13
        },
        {
           "name": "陳盈妙",
           "score": 15
        }
     ]
  },
   {
     "team": "【啟迪】走～一同去郊遊",
     "total": 97,
     "weight": 0,
     "members": [
        {
           "name": "楊凱婷",
           "score": 21
        },
        {
           "name": "鄭伊雯",
           "score": 19
        },
        {
           "name": "王怡雯",
           "score": 17
        },
        {
           "name": "許世佳",
           "score": 20
        },
        {
           "name": "孫薰懋",
           "score": 20
        }
     ]
  },
   {
     "team": "【聚碩】Sandy與她的小夥伴",
     "total": 96,
     "weight": 0,
     "members": [
        {
           "name": "李雅婷",
           "score": 21
        },
        {
           "name": "潘一貝",
           "score": 18
        },
        {
           "name": "汪瑞筠",
           "score": 20
        },
        {
           "name": "林欣怡",
           "score": 18
        },
        {
           "name": "謝易伶",
           "score": 19
        }
     ]
  },
   {
     "team": "【聚碩】健人就是腳勤",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "張育菱",
           "score": 21
        },
        {
           "name": "張珮菱",
           "score": 21
        },
        {
           "name": "許憶懃",
           "score": 21
        },
        {
           "name": "黃竹吟",
           "score": 20
        },
        {
           "name": "林宣穎",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】走路去紐約",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "陳景琳",
           "score": 20
        },
        {
           "name": "紀仲珈",
           "score": 21
        },
        {
           "name": "馮英豪",
           "score": 21
        },
        {
           "name": "陳婷婷",
           "score": 21
        },
        {
           "name": "鄭瑞甄",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】Lucky 7",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "張宏榮",
           "score": 21
        },
        {
           "name": "石修武",
           "score": 21
        },
        {
           "name": "李侃謙",
           "score": 21
        },
        {
           "name": "陳詩書",
           "score": 21
        },
        {
           "name": "伍以文",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】人在江湖走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "江立妤",
           "score": 21
        },
        {
           "name": "倪慧娟",
           "score": 21
        },
        {
           "name": "尤貞予",
           "score": 21
        },
        {
           "name": "賴梅櫻",
           "score": 21
        },
        {
           "name": "周淑惠",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】步步高升",
     "total": 74,
     "weight": 0,
     "members": [
        {
           "name": "吳雅璉",
           "score": 11
        },
        {
           "name": "高姚鈺",
           "score": 21
        },
        {
           "name": "陳郁淳",
           "score": 14
        },
        {
           "name": "程靖婷",
           "score": 13
        },
        {
           "name": "秦薇",
           "score": 15
        }
     ]
  },
   {
     "team": "【啟迪】走路工",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "黃淑芬",
           "score": 19
        },
        {
           "name": "紀佩伶",
           "score": 21
        },
        {
           "name": "周雅慧",
           "score": 20
        },
        {
           "name": "許巧錚",
           "score": 21
        },
        {
           "name": "曾明珠",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】阿魯Go!",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "林家寧",
           "score": 21
        },
        {
           "name": "張美雲",
           "score": 21
        },
        {
           "name": "石佳佩",
           "score": 21
        },
        {
           "name": "楊鈞凱",
           "score": 21
        },
        {
           "name": "黃柏揚",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】欲行去隊(台)",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "鄧雁玲",
           "score": 21
        },
        {
           "name": "王盈璇",
           "score": 21
        },
        {
           "name": "楊雅婷",
           "score": 21
        },
        {
           "name": "丁淑盈",
           "score": 21
        },
        {
           "name": "詹璟霖",
           "score": 20
        }
     ]
  },
   {
     "team": "【聚碩】SVTLE",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "董怡妏",
           "score": 21
        },
        {
           "name": "張家綾",
           "score": 21
        },
        {
           "name": "鍾怡婷",
           "score": 21
        },
        {
           "name": "劉子寧",
           "score": 21
        },
        {
           "name": "陳姈諭",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】GoGo肉",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "呂騏任",
           "score": 9
        },
        {
           "name": "林育呈",
           "score": 21
        },
        {
           "name": "張嘉晏",
           "score": 21
        },
        {
           "name": "呂相佩",
           "score": 21
        },
        {
           "name": "劉詠欣",
           "score": 20
        }
     ]
  },
   {
     "team": "【聚碩】民權29-1",
     "total": 92,
     "weight": 0,
     "members": [
        {
           "name": "陳家祥",
           "score": 21
        },
        {
           "name": "黃鴻熙",
           "score": 20
        },
        {
           "name": "許崇翰",
           "score": 17
        },
        {
           "name": "許伯銓",
           "score": 19
        },
        {
           "name": "呂麗榕",
           "score": 15
        }
     ]
  },
   {
     "team": "【啟迪】偉恩好棒棒",
     "total": 25,
     "weight": 0,
     "members": [
        {
           "name": "宋信賢",
           "score": 8
        },
        {
           "name": "張嘉傑",
           "score": 2
        },
        {
           "name": "陳宥臺",
           "score": 4
        },
        {
           "name": "李敬智",
           "score": 3
        },
        {
           "name": "邱凱詣",
           "score": 8
        }
     ]
  },
   {
     "team": "【聚碩】寶可夢孵蛋器",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "周香蘭",
           "score": 21
        },
        {
           "name": "曾英宸",
           "score": 21
        },
        {
           "name": "宋柏儒",
           "score": 21
        },
        {
           "name": "陳愷",
           "score": 19
        },
        {
           "name": "李宗遠",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】民權29-2",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "何靜怡",
           "score": 21
        },
        {
           "name": "黃貞文",
           "score": 21
        },
        {
           "name": "郭慧如",
           "score": 17
        },
        {
           "name": "陳國銘",
           "score": 20
        },
        {
           "name": "程聖安",
           "score": 21
        }
     ]
  },
   {
     "team": "【聚碩】瘦不了",
     "total": 82,
     "weight": 0,
     "members": [
        {
           "name": "曾昕儀",
           "score": 12
        },
        {
           "name": "鐘湘筑",
           "score": 21
        },
        {
           "name": "邱雨晨",
           "score": 21
        },
        {
           "name": "王珮伃",
           "score": 12
        },
        {
           "name": "吳岱穎",
           "score": 16
        }
     ]
  },
   {
     "team": "【聚碩】公道五路走9遍",
     "total": 95,
     "weight": 0,
     "members": [
        {
           "name": "周佩貞",
           "score": 20
        },
        {
           "name": "范昕妤",
           "score": 20
        },
        {
           "name": "林俐君",
           "score": 18
        },
        {
           "name": "梁君萍",
           "score": 20
        },
        {
           "name": "陳雅琪",
           "score": 17
        }
     ]
  },
   {
     "team": "【聚碩】沒有這一隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "謝明達",
           "score": 21
        },
        {
           "name": "宋芸榛",
           "score": 21
        },
        {
           "name": "張秀梅",
           "score": 21
        },
        {
           "name": "潘淑芬",
           "score": 21
        },
        {
           "name": "張志遠",
           "score": 21
        }
     ]
  },
   {
     "team": "【明基三豐】BMT walker",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "謝易達",
           "score": 19
        },
        {
           "name": "林信宏",
           "score": 21
        },
        {
           "name": "古卉軒",
           "score": 20
        },
        {
           "name": "游愛茹",
           "score": 21
        },
        {
           "name": "劉紀葳",
           "score": 18
        }
     ]
  },
   {
     "team": "【明基三豐】減肥只是說說",
     "total": 83,
     "weight": 0,
     "members": [
        {
           "name": "萬復森",
           "score": 7
        },
        {
           "name": "何鈺文",
           "score": 16
        },
        {
           "name": "黎安安",
           "score": 20
        },
        {
           "name": "邱必詠",
           "score": 21
        },
        {
           "name": "蔡依霖",
           "score": 19
        }
     ]
  },
   {
     "team": "【怡安醫療】怡安湊一隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "陳柏均",
           "score": 21
        },
        {
           "name": "楊賀順",
           "score": 21
        },
        {
           "name": "陳素卿",
           "score": 21
        },
        {
           "name": "邱至偉",
           "score": 21
        },
        {
           "name": "李育函",
           "score": 21
        }
     ]
  },
   {
     "team": "【虹韻國際】步步為贏",
     "total": 56,
     "weight": 0,
     "members": [
        {
           "name": "何宜謙",
           "score": 10
        },
        {
           "name": "陳郁樺",
           "score": 7
        },
        {
           "name": "呂柔慧",
           "score": 19
        },
        {
           "name": "邱佳琦",
           "score": 0
        },
        {
           "name": "藍雪芳",
           "score": 20
        }
     ]
  },
   {
     "team": "【明基口腔】瘦不下來",
     "total": 56,
     "weight": 0,
     "members": [
        {
           "name": "林采陵",
           "score": 16
        },
        {
           "name": "張聆萱",
           "score": 5
        },
        {
           "name": "冼蕙名",
           "score": 7
        },
        {
           "name": "余虹萱",
           "score": 19
        },
        {
           "name": "溫姿穎",
           "score": 9
        }
     ]
  },
   {
     "team": "【怡安醫療】風雨無阻之一步一腳印",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "徐佟蓮",
           "score": 20
        },
        {
           "name": "劉一德",
           "score": 21
        },
        {
           "name": "范姜秉畇",
           "score": 21
        },
        {
           "name": "林靜茹",
           "score": 21
        },
        {
           "name": "林詩琪",
           "score": 20
        }
     ]
  },
   {
     "team": "【怡安醫療】Da Q Li CW J 旋律",
     "total": 84,
     "weight": 0,
     "members": [
        {
           "name": "王怡茹",
           "score": 12
        },
        {
           "name": "蘇琮為",
           "score": 17
        },
        {
           "name": "謝閔繐",
           "score": 21
        },
        {
           "name": "林家瑋",
           "score": 14
        },
        {
           "name": "梁富閔",
           "score": 20
        }
     ]
  },
   {
     "team": "【勝品電通】勝券在握 品評卓逸",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "梁昆得",
           "score": 20
        },
        {
           "name": "潘信諭",
           "score": 19
        },
        {
           "name": "姜維義",
           "score": 18
        },
        {
           "name": "謝旻晃",
           "score": 21
        },
        {
           "name": "廖海丞",
           "score": 21
        }
     ]
  },
   {
     "team": "【勝品電通】必勝",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "盧季薇　",
           "score": 17
        },
        {
           "name": "蔡淑菁　",
           "score": 21
        },
        {
           "name": "吳云序　",
           "score": 21
        },
        {
           "name": "王治國　",
           "score": 21
        },
        {
           "name": "楊清泉　",
           "score": 21
        }
     ]
  },
   {
     "team": "【勝品電通】IQQ",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "黃錦順",
           "score": 21
        },
        {
           "name": "曾郁臻",
           "score": 21
        },
        {
           "name": "魏世旻",
           "score": 21
        },
        {
           "name": "鄒宗諺",
           "score": 20
        },
        {
           "name": "陳鈺丰",
           "score": 21
        }
     ]
  },
   {
     "team": "【勝品電通】早安午安運動團",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "呂偉民　",
           "score": 21
        },
        {
           "name": "許毓婷　",
           "score": 21
        },
        {
           "name": "楊雪靈　",
           "score": 21
        },
        {
           "name": "謝明勳　",
           "score": 21
        },
        {
           "name": "陳維荏",
           "score": 21
        }
     ]
  },
   {
     "team": "【勝品電通】勝品快樂企鵝隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "李月富",
           "score": 21
        },
        {
           "name": "林宜霆",
           "score": 21
        },
        {
           "name": "林秋淑　",
           "score": 21
        },
        {
           "name": "盧惠珊",
           "score": 21
        },
        {
           "name": "顏淑娜　",
           "score": 21
        }
     ]
  },
   {
     "team": "【勝品電通】勝品一窩瘋",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "陳冠宇　",
           "score": 21
        },
        {
           "name": "陳裕民",
           "score": 21
        },
        {
           "name": "林宣穎　",
           "score": 21
        },
        {
           "name": "黃承鈞　",
           "score": 21
        },
        {
           "name": "吳靜如　",
           "score": 21
        }
     ]
  },
   {
     "team": "【眾福】扭轉乾坤",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "黃昭維",
           "score": 21
        },
        {
           "name": "李岳諴",
           "score": 21
        },
        {
           "name": "黃忠賢",
           "score": 20
        },
        {
           "name": "蔡孝煌",
           "score": 21
        },
        {
           "name": "闕偉倉",
           "score": 21
        }
     ]
  },
   {
     "team": "【眾福】陽光女孩",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "褚佳玲",
           "score": 21
        },
        {
           "name": "許寶卿",
           "score": 21
        },
        {
           "name": "王淑娟 ",
           "score": 21
        },
        {
           "name": "曾筱亭",
           "score": 21
        },
        {
           "name": "賴雯玟",
           "score": 21
        }
     ]
  },
   {
     "team": "【眾福】飛龍在天",
     "total": 104,
     "weight": 0,
     "members": [
        {
           "name": "張碧華",
           "score": 21
        },
        {
           "name": "蘇麗卿",
           "score": 21
        },
        {
           "name": "林鈺玲",
           "score": 21
        },
        {
           "name": "林玲甄",
           "score": 20
        },
        {
           "name": "劉瑞真",
           "score": 21
        }
     ]
  },
   {
     "team": "【眾福】勇於爭先",
     "total": 69,
     "weight": 0,
     "members": [
        {
           "name": "莊皓宇",
           "score": 14
        },
        {
           "name": "陳源晉",
           "score": 14
        },
        {
           "name": "劉丞凱",
           "score": 9
        },
        {
           "name": "賴信安",
           "score": 16
        },
        {
           "name": "詹智文",
           "score": 16
        }
     ]
  },
   {
     "team": "【眾福】非我莫屬",
     "total": 101,
     "weight": 0,
     "members": [
        {
           "name": "李冠達",
           "score": 21
        },
        {
           "name": "李少棠",
           "score": 19
        },
        {
           "name": "王智威",
           "score": 20
        },
        {
           "name": "李建偉",
           "score": 21
        },
        {
           "name": "吳炫臻",
           "score": 20
        }
     ]
  },
   {
     "team": "【矽瑪】走著瞧",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "游淑芬",
           "score": 21
        },
        {
           "name": "吳瑞鈞",
           "score": 21
        },
        {
           "name": "簡婉怡",
           "score": 21
        },
        {
           "name": "游秀任",
           "score": 18
        },
        {
           "name": "徐民銓",
           "score": 21
        }
     ]
  },
   {
     "team": "【矽瑪】向前走",
     "total": 100,
     "weight": 0,
     "members": [
        {
           "name": "林婷婉",
           "score": 21
        },
        {
           "name": "李喬喻",
           "score": 21
        },
        {
           "name": "蔡孟鈞",
           "score": 20
        },
        {
           "name": "陳志維",
           "score": 19
        },
        {
           "name": "吳米捷",
           "score": 19
        }
     ]
  },
   {
     "team": "【國韶泰爾】國韶泰爾超級強",
     "total": 86,
     "weight": 0,
     "members": [
        {
           "name": "陳玉玲",
           "score": 17
        },
        {
           "name": "許碧芳",
           "score": 21
        },
        {
           "name": "林苑靖",
           "score": 21
        },
        {
           "name": "張容禎",
           "score": 13
        },
        {
           "name": "林美秀",
           "score": 14
        }
     ]
  },
   {
     "team": "【醫強】醫強我們超強",
     "total": 103,
     "weight": 0,
     "members": [
        {
           "name": "郭源富",
           "score": 21
        },
        {
           "name": "邱玫芬",
           "score": 21
        },
        {
           "name": "黃俊浩",
           "score": 21
        },
        {
           "name": "高鈺婷",
           "score": 21
        },
        {
           "name": "王泓雯",
           "score": 19
        }
     ]
  },
   {
     "team": "【凱圖】想要減肥對不對",
     "total": 93,
     "weight": 0,
     "members": [
        {
           "name": "盧小玲 Shareen",
           "score": 16
        },
        {
           "name": "王麗珠 Anita",
           "score": 20
        },
        {
           "name": "謝雅琳 Ella",
           "score": 20
        },
        {
           "name": "林廷昱 Jacky",
           "score": 18
        },
        {
           "name": "陳昱亨 Henry",
           "score": 19
        }
     ]
  },
   {
     "team": "【羅昇】羅昇 Top One",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "李長堅",
           "score": 21
        },
        {
           "name": "唐僑志",
           "score": 21
        },
        {
           "name": "林新德",
           "score": 21
        },
        {
           "name": "劉年進",
           "score": 21
        },
        {
           "name": "陳國美",
           "score": 21
        }
     ]
  },
   {
     "team": "【羅昇】羅昇GOGOGO",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "黃嘉文",
           "score": 21
        },
        {
           "name": "蔡恩達",
           "score": 21
        },
        {
           "name": "洪聖峰",
           "score": 21
        },
        {
           "name": "廖采瑩",
           "score": 21
        },
        {
           "name": "李宛蓉",
           "score": 21
        }
     ]
  },
   {
     "team": "【羅昇】羅昇~超越隊",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "李書麟",
           "score": 21
        },
        {
           "name": "陳玉兒",
           "score": 21
        },
        {
           "name": "王慈君",
           "score": 21
        },
        {
           "name": "謝慧祺",
           "score": 21
        },
        {
           "name": "李淑筠",
           "score": 21
        }
     ]
  },
   {
     "team": "【其陽科技】無敵風火輪",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "朱賢孝",
           "score": 21
        },
        {
           "name": "陳佳妤",
           "score": 21
        },
        {
           "name": "盧巧玲",
           "score": 21
        },
        {
           "name": "林諭萱",
           "score": 21
        },
        {
           "name": "周妤珎",
           "score": 21
        }
     ]
  },
   {
     "team": "【其陽科技】其貓好young",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "蔡旻諺",
           "score": 21
        },
        {
           "name": "羅惠郡",
           "score": 21
        },
        {
           "name": "高子惠",
           "score": 21
        },
        {
           "name": "劉韋彤",
           "score": 21
        },
        {
           "name": "吳巧玲",
           "score": 21
        }
     ]
  },
   {
     "team": "【其陽科技】Stroke's Team",
     "total": 99,
     "weight": 0,
     "members": [
        {
           "name": "蕭鈺儒",
           "score": 21
        },
        {
           "name": "林思婷",
           "score": 19
        },
        {
           "name": "涂政良",
           "score": 19
        },
        {
           "name": "吳懿紘",
           "score": 20
        },
        {
           "name": "李群翊",
           "score": 20
        }
     ]
  },
   {
     "team": "【其陽科技】國福隊",
     "total": 102,
     "weight": 0,
     "members": [
        {
           "name": "徐建忠",
           "score": 20
        },
        {
           "name": "蔡玉惠",
           "score": 21
        },
        {
           "name": "林育駿",
           "score": 20
        },
        {
           "name": "闕壯福",
           "score": 20
        },
        {
           "name": "李國偉",
           "score": 21
        }
     ]
  },
   {
     "team": "【拍檔】拍拍走",
     "total": 105,
     "weight": 0,
     "members": [
        {
           "name": "方淑珮",
           "score": 21
        },
        {
           "name": "林純宜",
           "score": 21
        },
        {
           "name": "程婉怡",
           "score": 21
        },
        {
           "name": "黃淨怡",
           "score": 21
        },
        {
           "name": "江依孝",
           "score": 21
        }
     ]
  },
   {
     "team": "【明基三豐】志在參加",
     "total": 56,
     "weight": 0,
     "members": [
        {
           "name": "管新寶",
           "score": 17
        },
        {
           "name": "林家弘",
           "score": 9
        },
        {
           "name": "沈勝龍",
           "score": 15
        },
        {
           "name": "鄒孝威",
           "score": 5
        },
        {
           "name": "吳淑晴",
           "score": 10
        }
     ]
  }
]